import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

import { Can, AbilityContext } from '../../_contexts/AbilitiesContext';

import { history } from '../../_helpers/history';
import RenderProfilePicture from '../../_helpers/profile-picture';

import { authenticationActions } from '../../_actions/authentication.actions';

import Logo from '../../_assets/images/logo.png'

import './style.css'
import ProviderOptions from './_Components/ProviderOptions';

class NavBar extends Component {

  static contextType = AbilityContext

  constructor(props) {
    super(props);

    this.unlisten = null;

    this.state = {
      isAdmin: false,
      location: '',
      isManager: false,
      isAxSAdmin: false,
      currentUser: props.currentUser,
      isScheduler: false,
      isLicensedProfessional: false,
    }
  }

  componentDidMount() {
    this.unlisten = history.listen(location => {
      this.setState({ location: location.pathname })
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentUser !== prevProps.currentUser) {
      this.setState({ currentUser: this.props.currentUser });
    }
  }

  componentWillUnmount() {
    this.unlisten()
  }

  canLibrary() {
    return this.context.can('forms', 'library') || this.context.can('questions', 'library');
  }

  canManage() {
    return this.context.can('manage', 'users') ||
      this.context.can('manage', 'roles') ||
      this.context.can('manage', 'locations') ||
      this.context.can('view', 'billing');
  }

  render() {
    const { currentUser } = this.state;
    const { clientServices } = this.props;

    const name = currentUser ? `${currentUser.FirstName} ${currentUser.LastName}` : '';

    return (
      <Navbar id="navbar">
        <Navbar.Brand as={Link} to="/dashboard" className="navbar-brand">
          <img src={Logo} alt="AxS Health Logo" height="30" className="d-line-block align-top" />
        </Navbar.Brand>

        <Nav className="mr-auto">
          <Nav.Link as={Link} to="/dashboard" className="nav-link" active={this.state.location.indexOf('/dashboard') === 0}>
            <i className="fas fa-chart-line"></i> Dashboard
          </Nav.Link>

          <Can I="view" a="form">
            <Nav.Link as={Link} to="/forms" className="nav-link" active={this.state.location.indexOf('/forms') === 0}>
              <i className="far fa-file-alt"></i> Forms
            </Nav.Link>
          </Can>

          <Can I="view" a="telehealth">
            <Nav.Link as={Link} to="/telehealth" className="nav-link" active={this.state.location.indexOf('/telehealth') === 0}>
              <i className="fas fa-laptop-medical"></i> Telehealth
            </Nav.Link>
          </Can>

          <Can I="view" an="events">
            <Nav.Link as={Link} to="/events" className="nav-link" active={this.state.location.indexOf('/events') === 0}>
              <i className="far fa-calendar-alt"></i> Events
            </Nav.Link>
          </Can>

          <Can I="view" a="messages">
            <Nav.Link as={Link} to="/messages" className="nav-link" active={this.state.location.indexOf('/messages') === 0}>
              <i className="far fa-comment-dots" aria-hidden="true"></i> Messages
            </Nav.Link>
          </Can>

          {clientServices && clientServices.INTAKE && clientServices.INTAKE.status &&
            <Can I="view" an="form">
              <Nav.Link as={Link} to="/intake" className="nav-link" active={this.state.location.indexOf('/intake') === 0}>
                <i className="fa fa-filter" aria-hidden="true"></i> Intake
              </Nav.Link>
            </Can>
          }

          { this.canLibrary() && 
          <NavDropdown active={
            this.state.location.indexOf('/questionnaires') === 0 ||
            this.state.location.indexOf('/questions') === 0
          }
            title={<><i className="fa fa-book" aria-hidden="true"></i> Library</>}>
              <Can I="forms" a="library">
                <NavDropdown.Item as={Link} to="/questionnaires"><i className="fa fa-book fa-fw" aria-hidden="true"></i> Forms</NavDropdown.Item>
              </Can>
              <Can I="questions" a="library">
                <NavDropdown.Item as={Link} to="/questions"><i className="fas fa-pencil-alt fa-fw" aria-hidden="true"></i> Questions</NavDropdown.Item>
              </Can>
          </NavDropdown>          
          }

          {clientServices && clientServices.VACCINE && clientServices.VACCINE.status &&
            <Nav.Link as={Link} to="/vaccine/cair" className="nav-link" active={this.state.location.indexOf('/vaccine') === 0}>
              <i className="fa fa-medkit" aria-hidden="true"></i> Vaccine
            </Nav.Link>
          }
        </Nav>

        { currentUser.UserType.Name === 'AxS Health' &&
          <ProviderOptions />
        }

        <NavDropdown title={name} className="user-dropdown" >
          { this.canManage() && <>
            <div className="ml-4 py-2"><b>Manage Account</b></div>
            <Can I="manage" a="users">
              <NavDropdown.Item className='py-2' as={Link} to="/account/users">Users</NavDropdown.Item>
            </Can>

            <Can I="manage" a="roles">
              <NavDropdown.Item className='py-2' as={Link} to="/account/roles">Roles</NavDropdown.Item>
            </Can>

            <Can I="manage" a="locations">
              <NavDropdown.Item className='py-2' as={Link} to="/account/locations">Locations</NavDropdown.Item>
            </Can>

            <Can I="manage" a="billing">
              <NavDropdown.Item className='py-2' as={Link} to="/account/billing">Billing</NavDropdown.Item>
            </Can>
          </> }


          <div className="ml-4 py-2"><b>User Settings</b></div>
          <NavDropdown.Item className='py-2' as={Link} to="/settings/user/profile">Edit Profile</NavDropdown.Item>
          <NavDropdown.Item className='py-2' as={Link} to="/settings/user/change-password">Change Password</NavDropdown.Item>

          <NavDropdown.Divider className="m-0" />
          <NavDropdown.Item className='py-2' onClick={() => this.props.dispatch(authenticationActions.logout())}><b>Logout</b></NavDropdown.Item>
        </NavDropdown>

        <Navbar.Brand className="navbar-brand">
          {currentUser && <RenderProfilePicture image={currentUser.ProfileUrl} circle cached={false} width={35} height={35} className='m-auto' />}
        </Navbar.Brand>
      </Navbar>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.currentUser,
    clientServices: state.client.services,
  }
}

export default connect(mapStateToProps)(NavBar);